import { useState } from "react";
import { Languages } from "lucide-react";
import { getLang, setLangValue } from "@/lib/i18n";

export const LangToggle = () => {
  const [, force] = useState(0);
  const toggle = () => {
    setLangValue(getLang() === "hi" ? "en" : "hi");
    force((n) => n + 1);
    window.dispatchEvent(new Event("langchange"));
  };
  return (
    <button onClick={toggle} data-testid="lang-toggle-btn" aria-label="Switch language"
      className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-[#E5DEC9] bg-white text-sm hover:border-[#1E3A2B] transition-colors">
      <Languages className="w-4 h-4 text-[#D96B43]" />{getLang() === "hi" ? "English" : "हिंदी"}
    </button>
  );
};
